import apiClient from './apiClient'

export const deleteSubCustomerDiscounts = async () => await apiClient.delete('/api/SubCustomerDiscounts')
export const getSubCustomerDiscounts = async (subCustomerId='') => await apiClient.get(`/api/SubCustomerDiscounts/${subCustomerId}`)
export const postSubCustomerDiscounts = async (payload) => await apiClient.post('/api/SubCustomerDiscounts', payload)
export const putSubCustomerDiscounts = async (subCustomerId, payload) => await apiClient.put(`/api/SubCustomerDiscounts/${subCustomerId}`, payload)
